import { WSSelect } from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";

import { useUrlQueryFilters } from "../../../../utils/router";
import { ImportBatchesFilters } from "../../types";

const FIRST_IMPORT_YEAR = 2021;

type Props = {
  defaultYear?: number;
};

export const FilterSelectYear: React.FC<Props> = ({ defaultYear }) => {
  const currentYear = new Date().getFullYear();
  const defaultYearValue = (defaultYear || currentYear).toString();
  const { filters, setFilters } = useUrlQueryFilters<ImportBatchesFilters>({
    year: defaultYearValue
  });

  const options = useMemo(() => {
    const years = Array.from(
      new Array(currentYear - FIRST_IMPORT_YEAR + 1),
      (_, index) => FIRST_IMPORT_YEAR + index
    ).reverse();

    return years.map(year => ({
      value: year.toString(),
      label: year.toString()
    }));
  }, [currentYear]);

  return (
    <WSSelect
      hideClearAction
      mode="single"
      options={options}
      value={filters.year}
      onChange={newValue =>
        setFilters({ ...filters, year: newValue as string })
      }
    />
  );
};
